module.exports = __webpack_public_path__ + "img/pic_sfewm@2x.ae91b099.png";